import { FlowExperimentContext, FlowExperimentContextProps } from './FlowExperimentContext'
import { useContext } from 'react'

export function useFlowExperimentContext(): FlowExperimentContextProps {
  const context = useContext(FlowExperimentContext)
  return context
}
